export class MoleculePanelServiceInfoWebspaceAccessComponent {
    public template = require('./panel-service-info-webspace-access.html');
}
